import moment from "moment";
import ModuleActionsMenu from "./ModuleActionsMenu";

export const createModuleTableColumns = (sortField, sortOrder, handleSort, onView, onEdit, handleActivate, handleDelete, onGenerateAI) => [
    {
        id: 'moduleName',
        Header: (
            <div className="modules-table-header df jcs aic cp" onClick={() => handleSort('moduleName')}>
                <span className="fw600 fs0-9rem c15">Module</span>
                <div className="modules-sort-icons ml0-5rem">
                    <i className={`fa fa-arrow-up ${sortField === 'moduleName' && sortOrder === 'asc' ? 'modules-sort-active' : ''}`} />
                    <i className={`fa fa-arrow-down ${sortField === 'moduleName' && sortOrder === 'desc' ? 'modules-sort-active' : ''}`} />
                </div>
            </div>
        ),
        accessor: module => {
            // Encode URL to handle spaces and special characters
            const encodedImageURL = module['imageURL'] ? encodeURI(module['imageURL']) : null;

            return (
                <div className="df jcs aic">
                    <div
                        className="modules-avatar w3rem h3rem br100 df jcc aic mr1rem"
                        style={{
                            backgroundColor: encodedImageURL ? 'transparent' : '#4a67ff',
                            backgroundImage: encodedImageURL ? `url("${encodedImageURL}")` : 'none',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            width: '42px',
                            height: '42px',
                            padding: '4px',
                            marginLeft: '8px'
                        }}
                    >
                        {!encodedImageURL && (
                            <span className="fw600 c1 fs1rem">
                                {(module['moduleName'] || 'M')[0].toUpperCase()}
                            </span>
                        )}
                    </div>
                    <div className="df fdc aifs jcfs">
                        <span className="fw600 c15 fs0-95rem w100 tal">{module['moduleName'].length > 30 ? module['moduleName'].substring(0, 30) + '...' : module['moduleName'] || '-'}</span>
                        {module['moduleDescription'] && (
                            <span className="fs0-75rem c15 mt0-25rem w100 tal" style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {module['moduleDescription']}
                            </span>
                        )}
                    </div>
                </div>
            )
        },
        minWidth: 280
    },
    {
        id: 'companyStage',
        Header: (
            <div className="modules-table-header df jcs aic cp" onClick={() => handleSort('companyStage')}>
                <span className="fw600 fs0-9rem c15">Objective</span>
                <div className="modules-sort-icons ml0-5rem">
                    <i className={`fa fa-arrow-up ${sortField === 'companyStage' && sortOrder === 'asc' ? 'modules-sort-active' : ''}`} />
                    <i className={`fa fa-arrow-down ${sortField === 'companyStage' && sortOrder === 'desc' ? 'modules-sort-active' : ''}`} />
                </div>
            </div>
        ),
        accessor: module => {
            const OBJECTIVE_STYLES = {
                Investment: { bg: '#e3f2fd', color: '#1976d2' },
                Exit: { bg: '#fce4ec', color: '#c62828' },
                Growth: { bg: '#e8f5e9', color: '#388e3c' },
            };
            const canonicalObjectives = Array.isArray(module['companyObjectives']) ? module['companyObjectives'] : [];
            const activeObjectives = Array.isArray(module['activeObjective']) ? module['activeObjective'] : [];
            const objectives = Array.from(new Set(
                (canonicalObjectives.length > 0 ? canonicalObjectives : activeObjectives)
                    .filter(Boolean)
            ));

            if (objectives.length === 0) {
                return <div className="df jcs"><span className="c15 fs0-85rem">-</span></div>;
            }

            return (
                <div className="df fww" style={{ gap: '4px' }}>
                    {objectives.sort((a, b) => a < b ? -1 : a > b ? 1 : 0).map(name => (
                        <span key={name} className="modules-type-badge fs0-75rem px0-75rem py0-25rem br15px fw500" style={{
                            backgroundColor: OBJECTIVE_STYLES[name]?.bg || '#f5f5f5',
                            color: OBJECTIVE_STYLES[name]?.color || '#757575'
                        }}>
                            {name}
                        </span>
                    ))}
                </div>
            );
        },
        minWidth: 150
    },
    {
        id: 'companySubscription',
        Header: (
            <div className="modules-table-header df jcs aic cp" onClick={() => handleSort('companySubscription')}>
                <span className="fw600 fs0-9rem c15">Subscription</span>
                <div className="modules-sort-icons ml0-5rem">
                    <i className={`fa fa-arrow-up ${sortField === 'companySubscription' && sortOrder === 'asc' ? 'modules-sort-active' : ''}`} />
                    <i className={`fa fa-arrow-down ${sortField === 'companySubscription' && sortOrder === 'desc' ? 'modules-sort-active' : ''}`} />
                </div>
            </div>
        ),
        accessor: module => {
            const SUB_STYLES = {
                Free: { bg: '#e8f5e9', color: '#388e3c' },
                Lite: { bg: '#fff3e0', color: '#f57c00' },
                Pro: { bg: '#e3f2fd', color: '#1976d2' },
                'Pro Portfolio': { bg: '#f3e5f5', color: '#7b1fa2' },
            };
            const canonicalTiers = Array.isArray(module['subscriptionTier']) ? module['subscriptionTier'] : [];
            const activeSubs = Array.isArray(module['activeSubscription']) ? module['activeSubscription'] : [];
            const subs = Array.from(new Set(
                (canonicalTiers.length > 0 ? canonicalTiers : activeSubs)
                    .filter(Boolean)
            ));

            if (subs.length === 0) {
                return <div className="df jcs"><span className="c15 fs0-85rem">-</span></div>;
            }

            return (
                <div className="df fww" style={{ gap: '4px' }}>
                    {subs.sort((a, b) => a < b ? -1 : a > b ? 1 : 0).map(name => (
                        <span key={name} className="modules-type-badge fs0-75rem px0-75rem py0-25rem br15px fw500" style={{
                            backgroundColor: SUB_STYLES[name]?.bg || '#f5f5f5',
                            color: SUB_STYLES[name]?.color || '#757575'
                        }}>
                            {name}
                        </span>
                    ))}
                </div>
            );
        },
        minWidth: 150
    },
    {
        id: 'isActive',
        Header: (
            <div className="modules-table-header df jcc aic cp" onClick={() => handleSort('isActive')}>
                <span className="fw600 fs0-9rem c15">Status</span>
                <div className="modules-sort-icons ml0-5rem">
                    <i className={`fa fa-arrow-up ${sortField === 'isActive' && sortOrder === 'asc' ? 'modules-sort-active' : ''}`} />
                    <i className={`fa fa-arrow-down ${sortField === 'isActive' && sortOrder === 'desc' ? 'modules-sort-active' : ''}`} />
                </div>
            </div>
        ),
        accessor: module => (
            <div className="df jcc">
                <span className={`modules-status-badge fs0-8rem px1rem py0-5rem br25px fw500 ${module['isActive'] ? 'modules-status-active' : 'modules-status-inactive'}`}>
                    {module['isActive'] ? 'Active' : 'Inactive'}
                </span>
            </div>
        ),
        minWidth: 100
    },
    {
        id: 'totalQuestions',
        Header: (
            <div className="modules-table-header df jcc aic cp" onClick={() => handleSort('totalQuestions')}>
                <span className="fw600 fs0-9rem c15">Questions</span>
                <div className="modules-sort-icons ml0-5rem">
                    <i className={`fa fa-arrow-up ${sortField === 'totalQuestions' && sortOrder === 'asc' ? 'modules-sort-active' : ''}`} />
                    <i className={`fa fa-arrow-down ${sortField === 'totalQuestions' && sortOrder === 'desc' ? 'modules-sort-active' : ''}`} />
                </div>
            </div>
        ),
        accessor: module => (
            <div className="df jcc">
                <span className="c15 fw500 fs0-9rem">
                    {module['totalQuestions'] || module['sections']?.length || 0}
                </span>
            </div>
        ),
        minWidth: 100
    },
    {
        id: 'createdAt',
        Header: (
            <div className="modules-table-header df jcs aic cp" onClick={() => handleSort('createdAt')}>
                <span className="fw600 fs0-9rem c15">Created</span>
                <div className="modules-sort-icons ml0-5rem">
                    <i className={`fa fa-arrow-up ${sortField === 'createdAt' && sortOrder === 'asc' ? 'modules-sort-active' : ''}`} />
                    <i className={`fa fa-arrow-down ${sortField === 'createdAt' && sortOrder === 'desc' ? 'modules-sort-active' : ''}`} />
                </div>
            </div>
        ),
        accessor: module => (
            <div className="df jcs">
                <span className="c15 fs0-85rem">
                    {module['createdAt']
                        ? moment(module['createdAt']).format('MMM DD, YYYY')
                        : module['createdDate'] || '-'}
                </span>
            </div>
        ),
        minWidth: 130
    },
    {
        Header: <div className="df jcc fw600 fs0-9rem c15">Actions</div>,
        Cell: props => (
            <ModuleActionsMenu
                module={props.original}
                onView={onView}
                onEdit={onEdit}
                onActivate={handleActivate}
                onDelete={handleDelete}
                onGenerateAI={onGenerateAI}
            />
        ),
        minWidth: 80,
        sortable: false
    }
];

